import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=53a76e25&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=53a76e25&prod&lang=css"
import style1 from "./OrderStatus.vue?vue&type=style&index=1&id=53a76e25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a76e25",
  null
  
)

export default component.exports